var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGift = function SvgGift(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6786 3.24772C11.7908 3.35142 11.8983 3.46109 12 3.57597C12.1017 3.46109 12.2092 3.35142 12.3214 3.24772C13.1129 2.5165 14.2246 2 15.5 2C17.433 2 19 3.567 19 5.5C19 6.0368 18.8792 6.54537 18.6632 7H20C20.5523 7 21 7.44772 21 8V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V8C3 7.44772 3.44772 7 4 7H5.33682C5.12085 6.54537 5 6.0368 5 5.5C5 3.567 6.567 2 8.5 2C9.77537 2 10.8871 2.5165 11.6786 3.24772ZM7 5.5C7 4.67157 7.67157 4 8.5 4C9.22463 4 9.86289 4.29314 10.3214 4.71675C10.7963 5.15551 11 5.65537 11 6V7H8.5C7.67157 7 7 6.32843 7 5.5ZM17 5.5C17 6.32843 16.3284 7 15.5 7H13V6C13 5.65537 13.2037 5.15551 13.6786 4.71675C14.1371 4.29314 14.7754 4 15.5 4C16.3284 4 17 4.67157 17 5.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H11V22H6C4.89543 22 4 21.1046 4 20V13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22V13H20V20C20 21.1046 19.1046 22 18 22H13Z",
    fill: "white"
  })));
};
export default SvgGift;